/* eslint-disable global-require */
let errorSound: HTMLAudioElement | null = null;

if (typeof window !== 'undefined') {
  errorSound = new Audio(require('src/assets/sounds/error.wav'));
}

export const playErrorSound = () => {
  if (errorSound) {
    errorSound.play().catch(() => {
      // Ignore rejection to avoid console noise (e.g. if user hasn't interacted yet)
    });
  }
};
